export default __webpack_public_path__ + "static/normalized_coindesk-6fe92f1f76fdd47e0f14dde379db5b3a.svg";